import { render, staticRenderFns } from "./NewStaff.vue?vue&type=template&id=9a162d7e"
import script from "./NewStaff.vue?vue&type=script&lang=js"
export * from "./NewStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports